import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62c5c987"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "TechBridge", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createBlock(_component_v_footer, { class: "footer-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        justify: "center",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
            return (_openBlock(), _createBlock(_component_v_btn, {
              key: link.key,
              to: link.path,
              class: "mx-2",
              rounded: "xl",
              variant: "text"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(link.key), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128)),
          _createVNode(_component_v_col, {
            class: "text-center mt-4",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(new Date().getFullYear()) + " — ", 1),
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}